var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stack",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.861,
    height: 17.664,
    viewBox: "0 0 16.861 17.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.06,17.4.39,14.271A.735.735,0,0,1,0,13.586a.742.742,0,0,1,.394-.693s.582-.288,1.43-.7L7.06,14.65a3.51,3.51,0,0,0,2.653.01c1.47-.59,3.819-1.7,5.323-2.432l1.434.672a.8.8,0,0,1,0,1.378s-4.454,2.207-6.753,3.13A3.513,3.513,0,0,1,7.06,17.4Zm0-4.754L.39,9.518A.735.735,0,0,1,0,8.832a.742.742,0,0,1,.394-.693s.582-.288,1.43-.7L7.06,9.9a3.513,3.513,0,0,0,2.653.01c1.47-.591,3.819-1.7,5.323-2.432l1.434.672a.8.8,0,0,1,0,1.378s-4.454,2.207-6.753,3.13a3.51,3.51,0,0,1-2.653-.01Zm0-4.753L.39,4.764A.736.736,0,0,1,0,4.078a.74.74,0,0,1,.394-.692S4.848,1.179,7.148.256A3.51,3.51,0,0,1,9.8.265l6.67,3.128a.735.735,0,0,1,.39.685.741.741,0,0,1-.394.693S12.013,6.978,9.713,7.9a3.51,3.51,0,0,1-2.653-.01Z",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/Level.27a4959cb0acdfbf4c0f6585680bfe70.svg";
export { ForwardRef as ReactComponent };